module.exports = __webpack_public_path__ + "static/img/kenta.24e55d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/kenta.jpg
// module id = nsFW
// module chunks = 0